module.exports = __webpack_public_path__ + "media/buy-now/sample_box6-dc6bd0cb.png";